import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CallBackEndService } from '../call-back-end.service';

import { Observable } from 'rxjs/Rx';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
declare var getHexAscii: any;
@Component({
  selector: 'app-jonit-acc-holder',
  templateUrl: './jonit-acc-holder.component.html',
  styleUrls: ['./jonit-acc-holder.component.css']
})
export class JonitAccHolderComponent implements OnInit {
  scAccounts: any [];
  accountInfo: any ;
  error : string ='';
  custNoRequired:string='';
  accNoRequired:string='';
  debitCardAddress : any;
  addressDetails : any=[];
  isShow : string='page1';
  disableSub1Btn:boolean=false;
  custNo:string;
  accno:string;
  showError:string="";
jointdtl:any;
  custnumber:string;
  private _jsonURL = 'assets/SampleUrl.json';

  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService,
    private http : HttpClient) {
    this.scAccounts =JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.accountInfo=JSON.stringify(JSON.parse(sessionStorage.getItem('accountInfo')));
    this.custNo =sessionStorage.getItem('custNo');
    // alert(this.custNo);

  }

  public getJSON(): Observable<any> {
    return this.http.get(this._jsonURL);
  }

  ngOnInit() {
  }

  
  submotSecond()
  {

     if (this.accno===""||this.accno===null||this.accno===undefined)
  {
    // alert('account no is invalid');
    this.accNoRequired='no';
  }
  else{

     this.disableSub1Btn=true;
     this.spinnerService.show();
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    console.log("come inside");
    // alert('data is ');
    //this.isLoad = true;
    request.param1 = "0";
    request.param2 =this.custNo;
    request.param3 =this.accno;
    // request.param4=this.debitCardNumber;
    this.webService.getResponse(request, 'jointinfo').subscribe((data: IbResponse) => {
       this.spinnerService.hide();
      response = data;
      //this.isLoad = false;
      if (response !== null && response.status === 'S200') {
        // alert('data is '+JSON.stringify(data));
        this.jointdtl = response.param6;
        // alert(this.jointdtl);
        // console.log('Otp :' + response.param1);
        this.isShow = 'page2';
        // this.generatedOtp=response.param1;
        this.disableSub1Btn=false;
      } else if (response !== null) {
        this.error = response.param1;
        this.disableSub1Btn=false;
      } else {
        this.disableSub1Btn=false;
        this.error = 'Something Went Wrong Please Contact Customer Care';
      }
    });
  }
}
}
  





// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/jonit-acc-holder/jonit-acc-holder.component.ts